import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";

import fetcher from './../repository';
import { EntityProfile } from "../repository/models_v2";
import { PageBlockWrapper } from "../ui/PageBlockWrapper";
import { NavMenu } from '../ui/NavMenu';
import { Signature } from '../ui/Signature';
import { extractSlugFromHref } from "../app-helpers";

export const Sidebar = () => {
    const { slug } = useParams()
    const [ options, setOptions ] = useState<{label: string, slug: string}[]>([])

    useEffect(() => {
        fetcher.getRootProfileData()
            .then((data) => {
                const optionList = getOptions(data)
                setOptions(optionList)
            })
        }, [])

    return (
        <PageBlockWrapper isSidebar title="Entiteiten">
            <NavMenu selected={slug ?? ''} options={options} />

            <Signature />
        </PageBlockWrapper>
    )
}

const getOptions = (data: EntityProfile) => {
    if(!!data){
        return Object.entries(data['_links']['cg:entity'])
            .map( (entity, index, array) => {
                const visible_name = updateEntityLabelIntoName(entity[1].name)
                return {label: visible_name, slug: extractSlugFromHref(entity[1].href)}
            })
            .sort( (a, b) => a.label.charCodeAt(0) - b.label.charCodeAt(0));
    }
    return []
}

const updateEntityLabelIntoName = (value: string) => {
    switch (value) {
        case 'werkmaatschappij': return 'Werkmaatschappijen';
        case 'factuur-document': return 'Facturen';
        case 'vestiging': return 'Vestigingen';
        case 'lijstwerk-document': return 'Lijstwerk';
        case 'jaaropgave-document': return 'Jaaropgave';
        case 'loonstrook-document': return 'Loonstroken';
        case 'idchecker-document': return 'Idchecker';
        case 'werknemer': return 'Werknemer';
        case 'debiteur': return 'Debiteuren';
        case 'jaarwerk-document': return 'Jaarwerk';
        case 'mijnhandtekening-document': return 'Mijnhandtekening';
        default: return value.replace('-',' ').replace('_',' ');
    }
}
